import { BaseModel } from './BaseInterface';
export const RetirementBase: BaseModel[] = [
  {
    key: 'taxAdvantaged',
    userInput: 'Retirement',
    apiValue: 1,
    dbValue: 1
  },
  {
    key: 'taxable',
    userInput: 'Taxable',
    apiValue: 2,
    dbValue: 2
  }
];
